function init(root) {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = "true";
      const controller = new AbortController();
      const media = JSON.parse(root.querySelector("[data-srh-assets]").textContent);
      const liveProducts = JSON.parse(root.querySelector("[data-srh-products]").textContent);
      const campaignProducts = JSON.parse(root.querySelector("[data-srh-products-campaign]")?.textContent || "{}");
      function withHkCurrency(value) {
        var text = String(value || '');
        return text.indexOf('HK$') >= 0 ? text : text.replace('$', 'HK$');
      }
      Object.entries(campaignProducts).forEach(([handle, data]) => {
        if (liveProducts[handle]) liveProducts[handle] = Object.assign({}, liveProducts[handle], data);
      });
      Object.keys(liveProducts).forEach(function (handle) {
        if (liveProducts[handle] && liveProducts[handle].price) liveProducts[handle].price = withHkCurrency(liveProducts[handle].price);
      });
      const stockOverrides = JSON.parse(root.querySelector("[data-srh-stock-overrides]")?.textContent || "{}");
      const productImages = JSON.parse(root.querySelector("[data-srh-product-images]").textContent);
      const labels = JSON.parse(root.querySelector("[data-srh-labels]").textContent);
      const listenDocument = (name, fn) => document.addEventListener(name, fn, {signal: controller.signal});
      "use strict";
      window.dataLayer = window.dataLayer || [];
      function track(eventName, payload) {
        window.dataLayer.push(Object.assign({ event: eventName, page_type: "homepage_redesign" }, payload || {}));
      }
      root.querySelectorAll("[data-track]").forEach(function (item) {
        item.addEventListener("click", function () {
          track(item.dataset.track, {
            label: item.dataset.label || item.textContent.trim(),
            product: item.dataset.product || "",
            position: item.dataset.position || ""
          });
        });
      });

      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var heroSlides = Array.prototype.slice.call(root.querySelectorAll("[data-hero-slide]"));
      var heroDots = Array.prototype.slice.call(root.querySelectorAll("[data-hero-go]"));
      var pauseButton = root.querySelector("[data-hero-pause]");
      var heroIndex = 0;
      var heroPaused = reducedMotion;
      var heroTimer = null;
      function setHeroSlide(nextIndex, source) {
        heroIndex = nextIndex;
        heroSlides.forEach(function (slide, index) {
          var active = index === heroIndex;
          slide.classList.toggle("is-active", active);
          slide.setAttribute("aria-hidden", String(!active));
          slide.inert = !active;
        });
        heroDots.forEach(function (dot, index) { dot.classList.toggle("is-active", index === heroIndex); });
        track("hero_view", { slide_index: heroIndex, slide_name: labels["text_192"], source: source || "initial" });
      }
      function startHeroTimer() {
        window.clearInterval(heroTimer);
        if (heroPaused || heroSlides.length < 2) { return; }
        heroTimer = window.setInterval(function () { setHeroSlide((heroIndex + 1) % heroSlides.length, "autoplay"); }, 6500);
      }
      heroDots.forEach(function (dot) {
        dot.addEventListener("click", function () { setHeroSlide(Number(dot.dataset.heroGo), "control"); startHeroTimer(); });
      });
      if (pauseButton) {
        pauseButton.textContent = heroPaused ? labels["text_193"] : labels["text_009"];
        pauseButton.setAttribute("aria-pressed", String(heroPaused));
        pauseButton.addEventListener("click", function () {
          heroPaused = !heroPaused;
          pauseButton.textContent = heroPaused ? labels["text_193"] : labels["text_009"];
          pauseButton.setAttribute("aria-pressed", String(heroPaused));
          startHeroTimer();
        });
      }
      setHeroSlide(0, "initial");
      startHeroTimer();
      var hero = root.querySelector(".hero");
      hero.addEventListener("mouseenter", function () { window.clearInterval(heroTimer); });
      hero.addEventListener("mouseleave", startHeroTimer);
      hero.addEventListener("focusin", function () { window.clearInterval(heroTimer); });
      hero.addEventListener("focusout", function (event) { if (!hero.contains(event.relatedTarget)) { startHeroTimer(); } });
      listenDocument("visibilitychange", function () {
        if (document.hidden) { window.clearInterval(heroTimer); } else { startHeroTimer(); }
      });

      var revealItems = root.querySelectorAll(".reveal");
      if ("IntersectionObserver" in window && !reducedMotion) {
        var revealObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { entry.target.classList.add("is-visible"); observer.unobserve(entry.target); }
          });
        }, { threshold: .1, rootMargin: "0px 0px -4% 0px" });
        revealItems.forEach(function (item) { revealObserver.observe(item); });
      } else {
        revealItems.forEach(function (item) { item.classList.add("is-visible"); });
      }

      var featureData = {
        c500: { video: media["tech-c500-motion.mp4"], poster: media["tech-c500-motion-poster.jpg"], label: labels["text_032"], price: labels["text_023"], slug: "c500", name: "C500" },
        c300pro: { video: media["tech-c300pro-motion.mp4"], poster: media["tech-c300pro-motion-poster.jpg"], label: labels["text_194"], price: labels["text_027"], slug: "c300-pro", name: "C300 Pro" },
        s300: { video: media["tech-s300-motion.mp4"], poster: media["tech-s300-motion-poster.jpg"], label: labels["text_195"], price: labels["text_031"], slug: "s300", name: "S300" }
      };
      Object.entries(featureData).forEach(([key, item]) => { const live = liveProducts[item.slug]; if(live) { item.price=live.price; item.url=live.url; } });
      var featureSwitchTimer;
      var featureVideo = root.querySelector("#brand-feature-video");
      var featurePlayButton = root.querySelector("[data-feature-play]");
      var featureTabs = Array.prototype.slice.call(root.querySelectorAll("[data-feature]"));
      var featurePanels = Array.prototype.slice.call(root.querySelectorAll("[data-feature-panel]"));
      var featurePaused = reducedMotion;
      var featureInView = false;
      function syncFeaturePlayback() {
        featurePlayButton.textContent = featurePaused ? labels["text_196"] : labels["text_033"];
        featurePlayButton.setAttribute("aria-pressed", String(featurePaused));
        if (featurePaused || !featureInView || document.hidden) { featureVideo.pause(); return; }
        var playRequest = featureVideo.play();
        if (playRequest && playRequest.catch) { playRequest.catch(function () { featurePaused = true; syncFeaturePlayback(); }); }
      }
      featurePlayButton.addEventListener("click", function () { featurePaused = !featurePaused; syncFeaturePlayback(); });
      featureTabs.forEach(function (tab, index) {
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.addEventListener("click", function () {
          var key = tab.dataset.feature;
          featureTabs.forEach(function (item) {
            var selected = item === tab;
            item.setAttribute("aria-selected", String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          featurePanels.forEach(function (panel) { panel.hidden = panel.dataset.featurePanel !== key; });
          root.querySelector("[data-motion-model]").textContent = featureData[key].label;
          root.querySelector("[data-motion-price]").textContent = featureData[key].price;
          var purchase = root.querySelector("[data-motion-buy]");
          purchase.href = featureData[key].url;
          purchase.dataset.product = featureData[key].name;
          purchase.setAttribute("aria-label", labels["text_197"] + featureData[key].name);
          featureVideo.classList.add("is-changing");
          window.clearTimeout(featureSwitchTimer);
          featureSwitchTimer = window.setTimeout(function () {
            featureVideo.pause();
            featureVideo.poster = featureData[key].poster;
            featureVideo.src = featureData[key].video;
            featureVideo.setAttribute("aria-label", featureData[key].label);
            root.querySelector("#motion-fill").src = featureData[key].poster;
            featureVideo.load();
            featureVideo.classList.remove("is-changing");
            syncFeaturePlayback();
          }, reducedMotion ? 0 : 150);
          track("brand_feature_change", { feature: key });
        });
        tab.addEventListener("keydown", function (event) {
          if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") { return; }
          event.preventDefault();
          var offset = event.key === "ArrowRight" ? 1 : -1;
          var nextIndex = (index + offset + featureTabs.length) % featureTabs.length;
          featureTabs[nextIndex].focus();
          featureTabs[nextIndex].click();
        });
      });
      syncFeaturePlayback();
      if ("IntersectionObserver" in window) {
        var featureObserver = new IntersectionObserver(function (entries) {
          featureInView = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
          syncFeaturePlayback();
        }, { threshold: [0, .2] });
        featureObserver.observe(featureVideo);
      } else {
        featureInView = true;
        syncFeaturePlayback();
      }
      listenDocument("visibilitychange", syncFeaturePlayback);

      var youtubeButton = root.querySelector("[data-youtube-play]");
      youtubeButton.addEventListener("click", function () {
        var facade = root.querySelector("[data-youtube-facade]");
        var iframe = document.createElement("iframe");
        iframe.src = "https://www.youtube-nocookie.com/embed/nUODWFk-6EA?autoplay=1&rel=0&playsinline=1";
        iframe.title = "SIHOO Doro C300 Pro V2 English product introduction";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.referrerPolicy = "strict-origin-when-cross-origin";
        iframe.setAttribute("sandbox", "allow-scripts allow-same-origin allow-presentation");
        iframe.allowFullscreen = true;
        facade.replaceChildren(iframe);
      });

      var products = {
        c100: { name: "C100", price: labels["text_199"], image: media["product-c100.jpg"], url: "https://hk.sihooxchair.com/products/c100", available: false },
        c300lite: { name: "C300 Lite", price: labels["text_200"], image: media["product-c300lite.jpg"], url: "https://hk.sihooxchair.com/products/c300-lite", available: false },
        c300pro: { name: "C300 Pro", price: labels["text_027"], image: media["product-c300pro-cutout.jpg"], url: "https://hk.sihooxchair.com/products/c300-pro", available: false },
        c300i: { name: "C300i", price: labels["text_201"], image: media["product-c300i.jpg"], url: "https://hk.sihooxchair.com/products/c300i", available: false },
        c500: { name: "C500", price: labels["text_023"], image: media["product-c500-cutout.jpg"], url: "https://hk.sihooxchair.com/products/c500", available: false },
        c500i: { name: "C500i", price: labels["text_018"], image: media["product-c500i-cutout.jpg"], url: "https://hk.sihooxchair.com/products/c500i", available: false },
        s300: { name: "S300", price: labels["text_031"], image: media["product-s300-cutout.jpg"], url: "https://hk.sihooxchair.com/products/s300", available: false },
        t6: { name: "T6", price: labels["text_203"], image: media["product-t6.jpg"], url: "https://hk.sihooxchair.com/products/t6", available: false }
      };

      Object.entries(products).forEach(([key, item]) => {
        const handle = item.url.split('/products/')[1];
        const live = liveProducts[handle];
        if (live) {
          item.price = live.price;
          item.url = live.url;
          item.available = Boolean(live.available);
        }
        if (Object.prototype.hasOwnProperty.call(stockOverrides, handle)) item.available = Boolean(stockOverrides[handle]);
        if (productImages[key]) item.image = productImages[key];
      });

      root.querySelectorAll(".product-price, [data-motion-price], [data-result-price], .catalog-card-body a").forEach(function (node) {
        node.textContent = withHkCurrency(node.textContent);
      });

      root.querySelectorAll(".catalog-card[data-product-handle]").forEach(function (card) {
        var live = liveProducts[card.dataset.productHandle];
        if (live && !live.available) card.hidden = true;
      });
      root.querySelectorAll(".catalog-panel").forEach(function (panel) {
        var cards = Array.prototype.slice.call(panel.querySelectorAll(".catalog-card"));
        if (cards.length && cards.every(function (card) { return card.hidden; })) panel.hidden = true;
      });

      var inStockFallbackOrder = ["c300pro", "c500", "c300lite", "c100"];
      var finderInStockCopy = (function () {
        var language = String(document.documentElement.lang || "").toLowerCase();
        if (language.indexOf("en") === 0) {
          return {
            summary: "We’ve prioritized options that are currently available to order.",
            reason: "This option is available to order. Confirm the version and delivery details on its product page."
          };
        }
        if (language.indexOf("zh-cn") === 0 || language.indexOf("zh-hans") === 0) {
          return {
            summary: "已优先显示目前可下单的选择。",
            reason: "此款目前可下单；请在产品页确认版本与送货安排。"
          };
        }
        return {
          summary: "已優先顯示目前可下單的選擇。",
          reason: "此款目前可下單；請在產品頁確認版本與送貨安排。"
        };
      }());
      function firstInStock(candidates) {
        return candidates.find(function (key) { return products[key] && products[key].available; }) || "";
      }
      function resolveInStockRecommendation(recommendation) {
        var primary = firstInStock([recommendation.primary].concat(inStockFallbackOrder));
        var upgrade = firstInStock([recommendation.upgrade].concat(inStockFallbackOrder.filter(function (key) { return key !== primary; })));
        if (!primary || !upgrade) return recommendation;
        var usedFallback = primary !== recommendation.primary || upgrade !== recommendation.upgrade;
        recommendation.primary = primary;
        recommendation.upgrade = upgrade;
        recommendation.usedInStockFallback = usedFallback;
        if (usedFallback) {
          recommendation.summary = finderInStockCopy.summary;
          recommendation.primaryReason = finderInStockCopy.reason;
          recommendation.upgradeReason = finderInStockCopy.reason;
        }
        return recommendation;
      }
      var finderForm = root.querySelector("[data-finder-form]");
      var finderQuestions = Array.prototype.slice.call(root.querySelectorAll("[data-finder-step]"));
      var finderLabels = Array.prototype.slice.call(root.querySelectorAll("[data-finder-label]"));
      var finderResult = root.querySelector("[data-finder-result]");
      var resultSummary = root.querySelector("[data-result-summary]");
      var currentFinderStep = 0;
      function getChoice(name) {
        var checked = finderForm.querySelector('input[name="' + name + '"]:checked');
        return checked ? checked.value : "";
      }
      function setFinderStep(index, shouldFocus) {
        currentFinderStep = index;
        finderQuestions.forEach(function (question, questionIndex) { question.hidden = questionIndex !== index; });
        finderResult.hidden = index !== 3;
        finderLabels.forEach(function (label, labelIndex) {
          label.classList.toggle("is-active", index < 3 && labelIndex === index);
          label.classList.toggle("is-complete", index === 3 || labelIndex < index);
          if (index < 3 && labelIndex === index) { label.setAttribute("aria-current", "step"); } else { label.removeAttribute("aria-current"); }
        });
        if (shouldFocus) {
          var target = index === 3 ? finderResult : finderQuestions[index].querySelector("legend");
          if (target) { target.focus({ preventScroll: true }); }
        }
      }
      function getRecommendation(duration, priority, budget) {
        var result = {
          primary: "c300pro", upgrade: "s300",
          summary: labels["text_204"],
          primaryReason: labels["text_205"],
          upgradeReason: labels["text_206"]
        };
        if (budget === "value") {
          if (priority === "compact") {
            Object.assign(result, { primary: "c100", upgrade: "c300lite", summary: labels["text_207"], primaryReason: labels["text_208"], upgradeReason: labels["text_209"] });
          } else if (priority === "smart") {
            Object.assign(result, { primary: "c300lite", upgrade: "c300i", summary: labels["text_210"], primaryReason: labels["text_211"], upgradeReason: labels["text_212"] });
          } else {
            Object.assign(result, { primary: "c300lite", upgrade: "c300pro", summary: labels["text_213"], primaryReason: labels["text_214"], upgradeReason: labels["text_215"] });
          }
          return result;
        }
        if (budget === "mid") {
          if (priority === "smart") {
            Object.assign(result, { primary: "c300i", upgrade: "c500i", summary: labels["text_216"], primaryReason: labels["text_217"], upgradeReason: labels["text_218"] });
          } else if (priority === "compact") {
            Object.assign(result, { primary: "c100", upgrade: "c300lite", summary: labels["text_219"], primaryReason: labels["text_220"], upgradeReason: labels["text_221"] });
          } else if (priority === "recline") {
            Object.assign(result, { primary: "c300pro", upgrade: "s300", summary: labels["text_222"], primaryReason: labels["text_223"], upgradeReason: labels["text_224"] });
          } else if (duration === "extended") {
            Object.assign(result, { primary: "s300", upgrade: "c500", summary: labels["text_225"], primaryReason: labels["text_226"], upgradeReason: labels["text_227"] });
          }
          return result;
        }
        if (priority === "smart") {
          Object.assign(result, { primary: "c500i", upgrade: "t6", summary: labels["text_228"], primaryReason: labels["text_229"], upgradeReason: labels["text_230"] });
        } else if (priority === "recline") {
          Object.assign(result, { primary: "s300", upgrade: "c500", summary: labels["text_225"], primaryReason: labels["text_226"], upgradeReason: labels["text_227"] });
        } else if (priority === "compact") {
          Object.assign(result, { primary: "c300pro", upgrade: "c500", summary: labels["text_234"], primaryReason: labels["text_235"], upgradeReason: labels["text_227"] });
        } else {
          Object.assign(result, { primary: "c500", upgrade: "c500i", summary: duration === "extended" ? labels["text_236"] : labels["text_237"], primaryReason: labels["text_238"], upgradeReason: labels["text_239"] });
        }
        return result;
      }
      function waitForImage(url) {
        return new Promise(function (resolve) {
          var preload = new Image();
          var timer;
          var done = function () { window.clearTimeout(timer); preload.onload = null; preload.onerror = null; resolve(); };
          preload.decoding = "async";
          preload.onload = done;
          preload.onerror = done;
          preload.src = url;
          timer = window.setTimeout(done, 6000);
          if (preload.complete) done();
        });
      }
      async function renderFinderResult() {
        var duration = getChoice("duration");
        var priority = getChoice("priority");
        var budget = getChoice("budget");
        var recommendation = resolveInStockRecommendation(getRecommendation(duration, priority, budget));
        if (budget === "value" && priority === "smart" && !recommendation.usedInStockFallback) {
          recommendation.summary = finderResult.dataset.budgetSummary;
          recommendation.primaryReason = finderResult.dataset.budgetPrimaryReason;
          recommendation.upgradeReason = finderResult.dataset.budgetUpgradeReason;
        }
        await Promise.all([waitForImage(products[recommendation.primary].image), waitForImage(products[recommendation.upgrade].image)]);
        resultSummary.textContent = recommendation.summary;
        ["primary", "upgrade"].forEach(function (role) {
          var card = root.querySelector('[data-result-card="' + role + '"]');
          var item = products[recommendation[role]];
          var image = card.querySelector("[data-result-image]");
          var link = card.querySelector("[data-result-link]");
          image.src = item.image;
          image.alt = labels["text_240"] + item.name + labels["text_241"];
          card.querySelector("[data-result-name]").textContent = item.name;
          card.querySelector("[data-result-reason]").textContent = recommendation[role + "Reason"];
          card.querySelector("[data-result-price]").textContent = item.price;
          var roleLabel = card.querySelector("[data-result-role]");
          roleLabel.textContent = budget === "value" && priority === "smart" ? roleLabel.dataset.budgetLabel : (role === "primary" ? labels["text_070"] : labels["text_074"]);
          card.querySelector("[data-result-link-label]").textContent = role === "primary" ? labels["text_072"] : labels["text_076"];
          link.href = item.url;
          link.dataset.product = item.name;
        });
        track("finder_complete", {
          duration: duration, priority: priority, budget: budget,
          primary_product: products[recommendation.primary].name,
          upgrade_product: products[recommendation.upgrade].name
        });
      }
      root.querySelectorAll("[data-finder-next]").forEach(function (button) {
        button.addEventListener("click", function () {
          var next = Math.min(currentFinderStep + 1, 2);
          setFinderStep(next, true);
          track("finder_step", { step: next, direction: "next" });
        });
      });
      root.querySelectorAll("[data-finder-back]").forEach(function (button) {
        button.addEventListener("click", function () {
          var next = Math.max(currentFinderStep - 1, 0);
          setFinderStep(next, true);
          track("finder_step", { step: next, direction: "back" });
        });
      });
      finderForm.addEventListener("submit", async function (event) {
        event.preventDefault();
        var submitButton = event.submitter || finderForm.querySelector('[data-finder-step="2"] button[type="submit"]');
        submitButton.disabled = true;
        finderForm.setAttribute("aria-busy", "true");
        try {
          await renderFinderResult();
          setFinderStep(3, true);
        } finally {
          submitButton.disabled = false;
          finderForm.removeAttribute("aria-busy");
        }
      });
      root.querySelector("[data-finder-restart]").addEventListener("click", function () {
        setFinderStep(2, true);
        track("finder_step", { step: 2, direction: "edit" });
      });
      setFinderStep(0, false);

      if ("IntersectionObserver" in window) {
        var seenProducts = {};
        var productObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) { return; }
            var name = entry.target.dataset.productCard;
            if (!seenProducts[name]) { seenProducts[name] = true; track("product_card_view", { product: name }); }
          });
        }, { threshold: .5 });
        root.querySelectorAll("[data-product-card]").forEach(function (card) { productObserver.observe(card); });
      }
      const header = document.querySelector('.section-header');
      const measureHeader = () => root.style.setProperty('--header-h', (header ? header.getBoundingClientRect().height : 66) + 'px');
      const headerObserver = new ResizeObserver(measureHeader); if(header)headerObserver.observe(header); measureHeader();
      root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
        const target=root.querySelector(link.getAttribute('href')); if(!target)return;
        event.preventDefault(); window.scrollTo({top:target.getBoundingClientRect().top+window.scrollY-parseFloat(root.style.getPropertyValue('--header-h')),behavior:reducedMotion?'auto':'smooth'});
      }));
      root._srhCleanup = () => { controller.abort(); window.clearInterval(heroTimer); window.clearTimeout(featureSwitchTimer); featureVideo.pause(); headerObserver.disconnect(); [revealObserver, featureObserver, productObserver].forEach(o=>{if(o)o.disconnect();}); };
    }
    init(document.getElementById('srh-home-preview'));
    if (!window.srhPreviewEvents) {
      document.addEventListener('shopify:section:load', () => init(document.getElementById('srh-home-preview')));
      document.addEventListener('shopify:section:unload', event => { const root=event.target.querySelector('#srh-home-preview'); if(root && root._srhCleanup)root._srhCleanup(); });
      window.srhPreviewEvents=true;
    }
